import { Avatar, Loader, MantineSize, Popover } from "@mantine/core";
import { UserFields } from "../types/user.types";
import { ContactFields } from "../types/contact.types";

const avatarColors = [
  'orange.7',
  'lime.7',
  'pink.7',
  'violet.7',
  'blue.7',
  'teal.7',
];

interface UserAvatarProps {
  user: UserFields | ContactFields;
  size?: MantineSize;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export default function UserAvatar({
  user,
  onMouseEnter,
  onMouseLeave,
  size = 'md',
}: UserAvatarProps) {
  let initials;

  if ('name' in user && typeof user.name === 'string') {
    initials = user.name.split(/\s+/).map(i => i.slice(0, 1)).join('');
  } else if ('username' in user && typeof user.username === 'string') {
    initials = (
      user.username.slice(-4, -3) + user.username.slice(0, 1)
    ).toUpperCase();
  }

  return (
    <Avatar
      key={user.id}
      size={size}
      color={!!user.id ?
        avatarColors[user.id % avatarColors.length] :
        'gray.7'
      }
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {initials}
    </Avatar>
  )
}